import { render, staticRenderFns } from "./EntityDetail.vue?vue&type=template&id=15aa4d4c&scoped=true"
import script from "./EntityDetail.vue?vue&type=script&lang=js"
export * from "./EntityDetail.vue?vue&type=script&lang=js"
import style0 from "./EntityDetail.vue?vue&type=style&index=0&id=15aa4d4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa4d4c",
  null
  
)

export default component.exports